function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_9",
  "data-name": "Group 9",
  transform: "translate(727 -1584.14)"
}, React.createElement("g", {
  id: "folder-24px",
  transform: "translate(-727 1584.14)"
}, React.createElement("path", {
  id: "Path_15",
  "data-name": "Path 15",
  d: "M0,0H83.234V83.234H0Z",
  fill: "none"
}), React.createElement("path", {
  id: "Path_16",
  "data-name": "Path 16",
  d: "M29.745,4H8.936a6.927,6.927,0,0,0-6.9,6.936L2,52.553a6.957,6.957,0,0,0,6.936,6.936H64.425a6.957,6.957,0,0,0,6.936-6.936V17.872a6.957,6.957,0,0,0-6.936-6.936H36.681Z",
  transform: "translate(4.936 9.872)"
})), React.createElement("g", {
  id: "qr_code-24px",
  transform: "translate(-690.5 1613.5)"
}, React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5"
}, React.createElement("rect", {
  id: "Rectangle_4",
  "data-name": "Rectangle 4",
  width: 36,
  height: 36,
  transform: "translate(-0.5 -0.5)",
  fill: "none"
})), React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(4.438 4.438)"
}, React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6"
}, React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M3,14.833H14.833V3H3ZM5.958,5.958h5.917v5.917H5.958Z",
  transform: "translate(-3 -3)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M3,24.833H14.833V13H3Zm2.958-8.875h5.917v5.917H5.958Z",
  transform: "translate(-3 1.792)",
  fill: "#fff"
}), React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M13,3V14.833H24.833V3Zm8.875,8.875H15.958V5.958h5.917Z",
  transform: "translate(1.792 -3)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_5",
  "data-name": "Rectangle 5",
  width: 3,
  height: 3,
  transform: "translate(24.063 24.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  width: 3,
  height: 3,
  transform: "translate(15.063 15.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  width: 3,
  height: 3,
  transform: "translate(18.063 18.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 3,
  height: 3,
  transform: "translate(15.063 21.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 3,
  height: 3,
  transform: "translate(18.063 24.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  width: 3,
  height: 3,
  transform: "translate(21.063 21.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  width: 3,
  height: 3,
  transform: "translate(21.063 15.063)",
  fill: "#fff"
}), React.createElement("rect", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  width: 3,
  height: 3,
  transform: "translate(24.063 18.063)",
  fill: "#fff"
})))));

var SvgObjectId = function SvgObjectId(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "MuiSvgIcon-root svg-icon",
    width: 83.234,
    height: 83.234,
    viewBox: "0 0 83.234 83.234",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgObjectId, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/object-id.264521ab.svg";
export { ForwardRef as ReactComponent };